import { Component } from "react";
import Buttons from "../Buttons/Buttons";

// React only supports catching render-time errors via a class component's
// getDerivedStateFromError/componentDidCatch - there's no hook equivalent.
// This is separate from ErrorContext/GlobalErrorModal, which only surfaces
// errors that call code explicitly reports (API failures); an uncaught throw
// during render would otherwise unmount the whole tree to a blank page.
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Unhandled render error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            height: "100vh",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <h2>Something went wrong</h2>
          <p style={{ color: "#6b6a6a" }}>
            An unexpected error occurred. Please reload the page and try again.
          </p>
          <Buttons text="Reload Page" variant="primary" fullWidth={false} onClick={this.handleReload} />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
